import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IContractType } from "../../utils/types/models";

export default createEntityReducer<IContractType>(Endpoint.ContractTypes, Endpoint.ContractTypesList);
